/* eslint-disable no-useless-escape */
import { ContentBlock, ContentState } from "draft-js";
import { VideoType } from "entities/faqs/types";

export const findLinkEntities = (
  contentBlock: ContentBlock,
  callback: (start: number, end: number) => void,
  contentState: ContentState,
) => {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "LINK"
    );
  }, callback);
};

export const getVideoType = (url: string): VideoType | null => {
  if (!url) return null;

  // YouTube URL patterns
  if (
    url.match(
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/,
    )
  ) {
    return VideoType.Youtube;
  }

  // Vimeo URL patterns
  if (
    url.match(
      /vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/,
    )
  ) {
    return VideoType.Vimeo;
  }

  // Loom URL patterns
  if (url.match(/loom\.com\/share\/([a-zA-Z0-9]+)/)) {
    return VideoType.Loom;
  }

  return null;
};

export const parseVideoUrl = (url: string): string | null => {
  if (!url) return null;

  const videoType = getVideoType(url);

  if (videoType === VideoType.Youtube) {
    // Extract YouTube video ID and create embed URL
    const match = url.match(
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/,
    );
    if (match && match[1]) {
      return `https://www.youtube.com/embed/${match[1]}`;
    }
  }

  if (videoType === VideoType.Vimeo) {
    // Extract Vimeo video ID and create embed URL
    const match = url.match(
      /vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/,
    );
    if (match && match[2]) {
      return `https://player.vimeo.com/video/${match[2]}`;
    }
  }

  if (videoType === VideoType.Loom) {
    // Extract Loom video ID and create embed URL
    const match = url.match(/loom\.com\/share\/([a-zA-Z0-9]+)/);
    if (match && match[1]) {
      return `https://www.loom.com/embed/${match[1]}`;
    }
  }

  return null;
};
